import { Component, ElementRef, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { UmsService } from '../ums.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ExamEligibilityComponent } from '../exam-eligibility/exam-eligibility.component';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ChangePasswordComponent } from '../change-password/change-password.component';

interface FoodNode {
  name: string;

  icon: string;

  children?: FoodNode[];
}

const TREE_DATA: FoodNode[] = [
  {
    name: 'Contact Us',

    icon: 'dashboard',
  },

  {
    name: 'Academics',

    icon: 'dashboard',

    children: [
      {
        name: 'My Curriculum ',

        icon: '',

        children: [
          {
            name: 'Programme Core',

            icon: '',
          },

          {
            name: 'Programme Elective',

            icon: '',
          },

          {
            name: 'University Core',

            icon: '',
          },

          {
            name: 'University Elective',

            icon: '',
          },

          {
            name: 'Specialization Elective',

            icon: '',
          },

          {
            name: 'Non Credit Course',

            icon: '',
          },
        ],
      },

      {
        name: 'Menu 2',

        icon: '',

        children: [
          {
            name: 'Submenu 1',

            icon: '',
          },

          {
            name: 'Submenu 2',

            icon: '',
          },
        ],
      },
    ],
  },
];

@Component({
  selector: 'app-header',

  templateUrl: './header.component.html',

  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  default = true;
  aaa = false;
  username = 'teacher';
  role = 'teacher';
  menu = 'teacher';
  defaultlang = 'mr';
  menurole = 'student';
  dialogRef: MatDialogRef<any>;
  treeControl = new NestedTreeControl<FoodNode>((node) => node.children);
  dataSource = new MatTreeNestedDataSource<FoodNode>();
  headerlist;
  listParentMenu: any;
  userId: string;
  userData = {
    LoginFullName: 'N/A'
  }
  userForProfile;
  prfImg
  imgegeg
  StudentIdd: string;
  hideMenu = true;
  regitab = true;
  OpenAddmission = true
  disableExam = true
  ShowRollNo = false
  ShowExamTime = false
  subjectSelectioMenu = false;
  RgId: any;
  ADMRecords: any[];
  emid: any;
  SrNo = 0;
  zoomLevel: number = 1;
  addmissionData: any;
  CoCode: any;
  Eligibility: any;
  SessionStatus: string;
  sessionName: any;
  data1: string;
  FormParamete: string;
  Arr = [];
  grievanceUpdate = false;
  NotLeft = true
  Failed: boolean;
  ReExam: boolean;
  SessionNo: any;
  NotificationsData: any;
  unreadCount: number = 0;
  DisplayNotifications: any[] = []; // Holds only the top 3 notifications
  NotificationCount: any;
  NotificationAllData: any;
  errMsg: any;
  OldStudentName: any;
  ShowMenu: boolean = true;
  userType: string;
  ShowMenu1: boolean;
  constructor(
    private elRef: ElementRef,
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    public router: Router,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private renderer: Renderer2
  ) {
    translate.setDefaultLang('en');
  }
  loginName;
  StuFullName: string
  studentId = sessionStorage.getItem('StudentRGID');
  headerForm: FormGroup;
  ngOnInit(): void {
    this.grievanceUpdate = false;
    this.userType = this.umsService.getUserType();
    console.log('this.userType in header', this.userType);
    // this.Arr = Object.assign({}, ...this.data);
    this.checkSession()
    this.getSecretData();
    this.SrNo = 0;
    this.disableExam = false
    this.ShowRollNo = false
    this.ShowExamTime = false
    this.NotLeft = true
    this.prepopulation();
    // this.prepopulationPersonal();
    this.getUserData(this.studentId)

    // this.prfImg = sessionStorage.getItem('ProfileImg');
    this.headerlist = JSON.parse(localStorage.getItem('headerlist'));
    let the = localStorage.getItem('theme');
    if (the.length <= 0) {
      this.theme('blue');
    } else {
      this.theme(the);
    }
    this.ngAfterViewInit();
    this.headerForm = this.fb.group({
      StuRgNo: new FormControl(this.studentId),
      StuId: new FormControl(""),
    });


  }

  redirectSubscribe(e) {
    var link = document.createElement('a');
    link.setAttribute("href", e);
    link.click()
  }

  prepopulation() {
    console.log("im in");
    this.getList();
    // this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.OldStudentName = res.data[0].StuFullNameEng;
          this.SubjectSelectionData(res.data[0].StuId);
          this.prepopulationOfAddmission(res.data[0].StuId)


        }
      }
    })
  }

  getRgId(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.RgId = res.data[0]['RgId']
        this.searchExams(res.data[0]['RgId']);
        if (res.data[0]['RgStatus'] == 'L') {
          this.NotLeft = false;
        }
        else {
          this.NotLeft = true;
        }

        this.searchExams(res.data[0]['RgId'])
        this.GetFailStudStatus(res.data[0]['RgId'])
      }
      else {
        this.disableExam = true
      }
    })
  }


  searchExams(RgId) {
    let payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = this.CoCode
    this.umsService.fetchLatestEcid(payload).subscribe((res) => {

      if (res.status) {
        this.disableExam = false
        this.emid = res.data[0]['EmId']
        this.SrNo = res.data[0]['EmSrNo']
        this.getSubselectEditControl(res.data[0]['SubjectSelectionShId'])
      } else {
        this.disableExam = true
      }
    });
  }


  ngAfterViewInit(): void {
    this.aaa = true;
    this.prfImg = sessionStorage.getItem('ProfileImg');
    this.userForProfile = sessionStorage.getItem('LoginName');
    this.get()
    this.getCuttoffDate()
  }

  useLanguage(language: string) {
    if (language === 'mr') {
      this.defaultlang = 'en';
    } else {
      this.defaultlang = 'mr';
    }

    this.translate.use(language);
  }

  hasChild = (_: number, node: FoodNode) =>
    !!node.children && node.children.length > 0;

  loadParentMenu() {
    this.umsService.getParentsMenu().subscribe((res) => {
      // tslint:disable-next-line:no-shadowed-variable

      const TREE_DATA: FoodNode[] = res.data;

      this.listParentMenu = res.data;

      this.dataSource.data = TREE_DATA;
    });
  }

  loadStudentMenu() {
    this.umsService.getStudentMenu().subscribe((res) => {

      // tslint:disable-next-line:no-shadowed-variable

      const TREE_DATA: FoodNode[] = res.data;

      this.dataSource.data = TREE_DATA;
    });
  }

  loadTeacherMenu() {
    this.umsService.getTeachersMenu().subscribe((res) => {

      // tslint:disable-next-line:no-shadowed-variable

      const TREE_DATA: FoodNode[] = res.data;

      this.dataSource.data = TREE_DATA;
    });
  }

  toggermenu(e) {
    if (e === true) {
      this.default = false;
    } else {
      this.default = true;
    }
  }

  redirect(to): void {
    // this.spinner.show()
    this.router.navigate([to]);
    //this.spinner.hide();
  }

  getSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.Eligibility = res.projectPharam['EligibilityRule']
      } else {

      }
    });
  }


  changetheme(e) {
    console.log('eeeeee', e);

    const setActiveClass = (elementId) => {
      document.getElementById(elementId).setAttribute('class', 'nav-item active show');
    };

    let allowRedirection = true;
    // this.Update = true

    if (e == 'Exam-Fees' || e == 'Exam-Form') {
      if (this.RgId == undefined || this.RgId == null) {
        let data = {}
        data['message'] = "Schedule Not Open For This Activity"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
      else {
        this.spinner.show();
        this.umsService.fetchLatestEcid({ RgId: this.RgId, CoCode: sessionStorage.getItem("StuCoId") })
          .subscribe((res) => {
            if (res.status) {
              let payload = {};
              payload['EcShId'] = res.data[0]['ShId'];
              payload['EcInCode'] = " ";
              payload['EcOpId'] = 0;
              this.umsService.getSupExamEditRecord(payload).subscribe(
                (res) => {
                  if (res.status) {
                    this.spinner.hide();
                    const ExmForm = res.data.filter(record => record.EcInCode == 19);
                    if (ExmForm.length > 0) {
                      if (ExmForm[0]['EcStatus'] == 'U') {
                        this.redirect(e);
                        setActiveClass(e);
                        allowRedirection = true
                      }
                      else if (ExmForm[0]['EcStatus'] == 'O') {
                        if (e == 'Exam-Form') {
                          this.redirect('Exam-Form');
                          setActiveClass('Exam-Form');
                          //we have commented bcoz we are MBBS 2nd yr student directly so they don't have Eligibility
                          // if(this.Eligibility == true){
                          //   this.openExamEligibility(e);
                          // }
                          // else if(this.Eligibility == false){
                          //   this.redirect('Exam-Form');
                          //   setActiveClass('Exam-Form');
                          // }

                        }
                        else if (e == 'Exam-Fees') {
                          this.redirect('Exam-Fees');
                          setActiveClass('Exam-Fees');

                        }
                        this.disableExam = false;

                        allowRedirection = true

                      }
                      if (allowRedirection) {
                        setActiveClass(e);
                        this.redirect(e);
                      }
                    }
                    else if (ExmForm.length == 0) {
                      this.showPopup('Schedule Is Not Open For This Activity');
                      allowRedirection = false;
                    }

                  } else {
                    this.showPopup('Schedule Is Not Open For This Activity');
                    allowRedirection = false;
                  }
                });

            } else {
              this.spinner.hide()
              this.disableExam = true;
              this.showPopup('Schedule Is Not Open For This Activity');
              allowRedirection = false;
            }
            if (allowRedirection) {
              setActiveClass(e);
              this.redirect(e);
            }
          });
      }

    }
    else if (e == 'Admit-Card') {
      console.log('im insiode click on admit card');

      if (this.RgId == undefined || this.RgId == null) {
        let data = {}
        data['message'] = "Schedule Not Open For This Activity"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
      else {
        this.umsService.fetchLatestEcid({ RgId: this.RgId, CoCode: sessionStorage.getItem("StuCoId") })
          .subscribe((res) => {
            if (res.status) {
              let payload = {};
              payload['EcShId'] = res.data[0]['ShId'];
              payload['EcInCode'] = " ";
              payload['EcOpId'] = 0;
              this.umsService.getSupExamEditRecord(payload).subscribe(
                (res) => {
                  console.log('i have center allocation updated');

                  if (res.status) {
                    const ExmForm = res.data.filter(record => record.EcInCode == 20);
                    if (ExmForm.length > 0) {
                      if (ExmForm[0]['EcStatus'] == 'U') {
                        // this.redirect(e);
                        // setActiveClass(e);
                        allowRedirection = true
                        this.openExamEligibility(e);
                      }
                      else if (ExmForm[0]['EcStatus'] == 'O') {
                        this.showPopup('Schedule Is Not Open For This Activity');
                        allowRedirection = false;
                      }
                      if (allowRedirection) {
                        // setActiveClass(e);
                        // this.redirect(e);
                        // this.openExamEligibility(e);
                      }
                    }
                    else if (ExmForm.length == 0) {
                      this.showPopup('Schedule Is Not Open For This Activity');
                      allowRedirection = false;
                    }

                  } else {
                    this.showPopup('Schedule Is Not Open For This Activity');
                    allowRedirection = false;
                  }
                });
            }
            else {
              this.showPopup('Schedule Is Not Open For This Activity');
              allowRedirection = false;
            }
            if (allowRedirection) {
              // setActiveClass(e);
              // this.redirect(e);
              // this.openExamEligibility(e);
            }
          });
      }

    }
    else if (e == 'Fees') {
      if (this.SrNo == 0 || this.SrNo == 1) {
        let payload = {};
        this.ADMRecords = []
        payload['SnNo'] = sessionStorage.getItem('session');
        payload['InCode'] = 'ADFEE'
        payload['CgCode'] = sessionStorage.getItem("StuCgId");
        payload['CoCode'] = sessionStorage.getItem("StuCoId");
        this.umsService.CheckValidDate(payload).subscribe(res => {
          if (res.status) {
            const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId"));
            const today = new Date();
            const todayDateString = today.toISOString().split('T')[0];

            if (courseRecords.length > 0) {
              this.ADMRecords = courseRecords.filter(record => record.InCode === 'ADFEE');
            }
            let listCanOpen = false;
            if (this.ADMRecords.length == 0) {
              listCanOpen = false;

              this.showPopup('Schedule Is Not Open For This Activity');
              allowRedirection = false;
            }

            else if (this.ADMRecords.length > 0) {
              for (let item of this.ADMRecords) {
                if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
                  listCanOpen = true;
                  this.redirect(e);
                  setActiveClass(e);
                  allowRedirection = true
                  break;
                }
              }
            }


            if (!listCanOpen) {
              for (let item of this.ADMRecords) {
                if (todayDateString > item.ToDate.split('T')[0]) {
                  this.redirect(e);
                  setActiveClass(e);
                  allowRedirection = true
                  break;
                } else if (todayDateString < item.FromDate.split('T')[0]) {
                  this.showPopup('Schedule Is Not Open For This Activity');
                  allowRedirection = false;
                  break;
                }
              }
            }
            if (allowRedirection) {
              setActiveClass(e);
              this.redirect(e);
            }

          } else {
            this.showPopup('Schedule Is Not Open For This Activity');
            allowRedirection = false;
          }
          if (allowRedirection) {
            setActiveClass(e);
            this.redirect(e);
          }
        });
      }

      else if (this.SrNo > 1) {
        let data = {}
        data['message'] = "Already Paid"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }



    }
    else if (e == 'Marklist') {
      if (this.RgId == undefined || this.RgId == null) {
        let data = {}
        data['message'] = "Schedule Not Open For This Activity"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
      else {
        let payload = {};
        this.ADMRecords = []
        payload['SnNo'] = this.SessionNo;
        payload['InCode'] = 'MRKL'
        payload['CgCode'] = sessionStorage.getItem("StuCgId");
        payload['CoCode'] = sessionStorage.getItem("StuCoId");
        payload['EmId'] = this.emid
        this.umsService.CheckValidDate(payload).subscribe(res => {
          if (res.status) {
            const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId"));
            const today = new Date();
            const todayDateString = today.toISOString().split('T')[0];
            if (courseRecords.length > 0) {
              this.ADMRecords = courseRecords.filter(record => record.InCode === 'MRKL');
            }
            let listCanOpen = false;
            if (this.ADMRecords.length == 0) {
              listCanOpen = false;
              this.showPopup('Schedule Is Not Open For This Activity');
              allowRedirection = false;
            }
            else if (this.ADMRecords.length > 0) {
              for (let item of this.ADMRecords) {
                if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
                  listCanOpen = true;
                  this.redirect(e);
                  setActiveClass(e);
                  allowRedirection = true
                  break;
                }
              }
            }


            if (!listCanOpen) {
              for (let item of this.ADMRecords) {
                if (todayDateString > item.ToDate.split('T')[0]) {
                  this.redirect(e);
                  setActiveClass(e);
                  allowRedirection = true
                  break;
                } else if (todayDateString < item.FromDate.split('T')[0]) {
                  this.showPopup('Schedule Is Not Open For This Activity');
                  allowRedirection = false;
                  break;
                }
              }
            }
            if (allowRedirection) {
              setActiveClass(e);
              this.redirect(e);
            }

          } else {
            this.showPopup('Schedule Is Not Open For This Activity');
            allowRedirection = false;
          }
          if (allowRedirection) {
            setActiveClass(e);
            this.redirect(e);
          }
        });
      }
    }
    else if (e == 'Subject-Selection') {
      // this.redirect(e);
      // setActiveClass(e);
      this.openExamEligibility(e);
      //  let payload = {};
      //   this.ADMRecords = []
      //   payload['SnNo'] = sessionStorage.getItem('session');
      //   payload['InCode'] = 'SubSe'
      //   payload['CgCode'] = sessionStorage.getItem("StuCgId");
      //   payload['CoCode'] = sessionStorage.getItem("StuCoId");
      //   // payload['EmId'] = this.emid
      //   this.umsService.CheckValidDate(payload).subscribe(res =>  {
      //     if (res.status) {
      //       const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId"));
      //       const today = new Date();
      //       const todayDateString = today.toISOString().split('T')[0];
      //       if (courseRecords.length > 0) {
      //         this.ADMRecords = courseRecords.filter(record => record.InCode === 'SubSe');
      //       }
      //       let listCanOpen = false;

      //       if(this.ADMRecords.length == 0){
      //         listCanOpen = false;
      //         this.showPopup('Schedule Is Not Open For This Activity');
      //         allowRedirection = false;
      //       }
      //       else if(this.ADMRecords.length > 0){
      //         for (let item of this.ADMRecords) {
      //           if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {               
      //             listCanOpen = true;
      //             this.redirect(e);
      //             setActiveClass(e);
      //             allowRedirection = true
      //             break;
      //           }
      //         }
      //       }


      //       if (!listCanOpen) {
      //         for (let item of this.ADMRecords) {
      //           if (todayDateString > item.ToDate.split('T')[0]) {
      //             this.redirect(e);
      //             setActiveClass(e);
      //             allowRedirection = true
      //             break;
      //           } else if (todayDateString < item.FromDate.split('T')[0]) {
      //             this.showPopup('Schedule Is Not Open For This Activity');
      //             allowRedirection = false;
      //             break;
      //           }
      //         }
      //       }
      //       if (allowRedirection) {
      //         setActiveClass(e);
      //         this.redirect(e);
      //       }

      //     } else {
      //       this.showPopup('Schedule Is Not Open For This Activity');
      //       allowRedirection = false;
      //     }
      //     if (allowRedirection) {
      //       setActiveClass(e);
      //       this.redirect(e);
      //     }
      //   });
      //   if (this.RgId == undefined || this.RgId == null) {
      //   let data = {}
      //   data['message'] = "Schedule Not Open For This Activity"
      //   data['title'] = 'Information'
      //   data['icon'] = 'fas fa-close'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // }
      // else{

      // }
    }
    else if (e == 'Optional-Subject-Selection') {
      this.redirect('Optional-Subject-Selection');
      setActiveClass(e);
    }
    else {
      // Default case

      document.getElementById('Dashboard').setAttribute('class', 'nav-item ');
      document.getElementById('Fees').setAttribute('class', 'nav-item show');
      setActiveClass(e);
      document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');
      document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');
      document.getElementById('Admit-Card').setAttribute('class', 'nav-item ');
      document.getElementById('Marklist').setAttribute('class', 'nav-item');
      document.getElementById('TC-LC-MC').setAttribute('class', 'nav-item');
      // document.getElementById('Complaint').setAttribute('class', 'nav-item');
      document.getElementById('exam-dashboard').setAttribute('class','nav-item');
      if (!allowRedirection) {
        allowRedirection = true; // Reset the flag to true for default cases
      }
      this.redirect(e);
    }

    if (e == 'Registration') {
      document.getElementById(e).setAttribute('class', 'nav-item active show ');

      document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Fees').setAttribute('class', 'nav-item');

      document.getElementById('Admit-Card').setAttribute('class', 'nav-item ');

      document.getElementById('Marklist').setAttribute('class', 'nav-item');

      document.getElementById('Complaint').setAttribute('class', 'nav-item');

      document.getElementById('TC-LC-MC').setAttribute('class', 'nav-item')
    } else if (e == 'Fees') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('Registration').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Admit-Card').setAttribute('class', 'nav-item ');

      document.getElementById('Marklist').setAttribute('class', 'nav-item');

      document.getElementById('Complaint').setAttribute('class', 'nav-item');

      document.getElementById('TC-LC-MC').setAttribute('class', 'nav-item')
    }

    // else if (e == 'Exam-Fees') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

    //   document.getElementById('Registration').setAttribute('class', 'nav-item ');

    //   document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

    //   document.getElementById('Fees').setAttribute('class', 'nav-item ');

    //   document.getElementById('Admit-Card').setAttribute('class', 'nav-item ');

    //   document.getElementById('Marklist').setAttribute('class', 'nav-item');
    // }
    // else if (e == 'Exam-Form') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

    //   document.getElementById('Registration').setAttribute('class', 'nav-item ');

    //   document.getElementById('Fees').setAttribute('class', 'nav-item ');

    //   document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');

    //   document.getElementById('Admit-Card').setAttribute('class', 'nav-item ');

    //   document.getElementById('Marklist').setAttribute('class', 'nav-item');
    // }
    // else if (e == 'Admit-Card') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

    //   document.getElementById('Registration').setAttribute('class', 'nav-item ');

    //   document.getElementById('Fees').setAttribute('class', 'nav-item ');

    //   document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');

    //   document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

    //   document.getElementById('Marklist').setAttribute('class', 'nav-item');

    //   document.getElementById('Complaint').setAttribute('class', 'nav-item');

    //   document.getElementById('TC-LC-MC').setAttribute('class', 'nav-item');
    // }
    else if (e == 'Marklist') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('Registration').setAttribute('class', 'nav-item ');

      document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

      document.getElementById('Admit-Card').setAttribute('class', 'nav-item');

      document.getElementById('Complaint').setAttribute('class', 'nav-item');

      document.getElementById('TC-LC-MC').setAttribute('class', 'nav-item');
    }
    else if (e == 'TC-LC-MC') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('Registration').setAttribute('class', 'nav-item ');

      document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

      document.getElementById('Admit-Card').setAttribute('class', 'nav-item');

      document.getElementById('Complaint').setAttribute('class', 'nav-item');
    }
    else if (e == 'Complaint') {
      document.getElementById(e).setAttribute('class', 'nav-item active show');

      document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('Registration').setAttribute('class', 'nav-item ');

      document.getElementById('Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

      document.getElementById('Admit-Card').setAttribute('class', 'nav-item');

      document.getElementById('TC-LC-MC').setAttribute('class', 'nav-item');
    }
    // } else if (e == 'Location') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('Settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('Dashboard').setAttribute('class', 'nav-item ');
    // }
    // else if (e == 'Registration') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('Settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('Dashboard').setAttribute('class', 'nav-item ');
    // } 
    // else if (e == 'Registration') {
    //   document.getElementById(e).setAttribute('class', 'nav-item active show');

    //   document.getElementById('master').setAttribute('class', 'nav-item ');

    //   document.getElementById('Settings').setAttribute('class', 'nav-item ');

    //   document.getElementById('Dashboard').setAttribute('class', 'nav-item ');
    // }
    else {
      document.getElementById('Dashboard').setAttribute('class', 'nav-item ');

      document.getElementById('Fees').setAttribute('class', 'nav-item show');

      document.getElementById(e).setAttribute('class', 'nav-item active show ');

      document.getElementById('Exam-Form').setAttribute('class', 'nav-item ');

      document.getElementById('Exam-Fees').setAttribute('class', 'nav-item ');

      document.getElementById('Admit-Card').setAttribute('class', 'nav-item ');

      document.getElementById('Marklist').setAttribute('class', 'nav-item');

      document.getElementById('Complaint').setAttribute('class', 'nav-item');

      document.getElementById('TC-LC-MC').setAttribute('class', 'nav-item');
    }
  }

  showPopup(message: string) {
    let data = {}
    data['message'] = message
    data['title'] = 'Information'
    data['icon'] = 'fas fa-close'
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  }

  theme(i) {
    if (i == 'white') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        'gray'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#aaaaaa'
      );

      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'gray');

      this.elRef.nativeElement.style.setProperty('--dark-border', 'gray');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        'gray'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        'black'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        'black'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'yellow') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#ffab00'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#efb960'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#ffab00'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#ffab00');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#ffab00'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#ffb10f'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#f0d6a1'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'red') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#ef8d89'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#ff4a42');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#ff4a42'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'green') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        'green'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#85b87f'
      );

      this.elRef.nativeElement.style.setProperty('--primary-bg-color', 'green');

      this.elRef.nativeElement.style.setProperty('--dark-border', 'green');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        'green'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        'green'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        'green'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else if (i == 'sky_blue') {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#96d1f1'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#03a2e2');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#03a2e2'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', 'white');

      localStorage.setItem('theme', i);
    } else {
      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-one',
        '#0c1d78'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-gradent-two',
        '#1b3ad4'
      );

      this.elRef.nativeElement.style.setProperty(
        '--primary-bg-color',
        '#0c1d78'
      );

      this.elRef.nativeElement.style.setProperty('--dark-border', '#0c1d78');

      this.elRef.nativeElement.style.setProperty(
        '--main-content-title',
        '#0c1d78'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-1',
        '#7787bc'
      );

      this.elRef.nativeElement.style.setProperty(
        '--breadcrumb-lable-2',
        '#8f9cc0'
      );

      this.elRef.nativeElement.style.setProperty('--side-sub-link', '#c7c7c7');

      localStorage.setItem('theme', i);
    }
  }

  x = ""
  colorchnage(e) {
    // alert(this.x)
    if (this.x == "") {
      document.getElementById(e).setAttribute('class', 'nav-sub-link active');
      this.x = e;
    } else if (this.x !== e) {
      document.getElementById(this.x).setAttribute('class', 'nav-sub-link');
      document.getElementById(e).setAttribute('class', 'nav-sub-link active');
      this.x = e;
    } else {
      document.getElementById(this.x).setAttribute('class', 'nav-sub-link');
      document.getElementById(e).setAttribute('class', 'nav-sub-link active');
      this.x = e;
    }
    // document.getElementById(this.x).setAttribute('class', 'nav-sub-link');


  }
  logout() {

    sessionStorage.removeItem('token');
    sessionStorage.clear();
    localStorage.clear();

    if (this.userType === 'new') {
      this.redirect('student-login');
    }
    else if (this.userType === 'old') {
      this.redirect('certificate-login');
    }
  }


  get() {
    let iconnnn = this.umsService.geticon();
    if (iconnnn !== null) {
      return this.umsService.geticon();

    } else {
      return this.umsService.getNoicon()
    }
  }


  getCuttoffDate() {
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getCuttoffDate(payload).subscribe((res) => {
      if (res.status) {
        this.regitab = true;
        this.OpenAddmission = false;
      }
      else {
        this.regitab = false;
        this.OpenAddmission = true;
      }
    })
  }

  zoom(action: string) {
    switch (action) {
      case 'A':
        this.zoomLevel = 1;
        break;
      case '-':
        if (this.zoomLevel > 0.5) {
          this.zoomLevel = Math.max(0.5, this.zoomLevel - 0.1);
        }
        break;
      case '+':
        if (this.zoomLevel < 1.5) {
          this.zoomLevel = Math.min(1.5, this.zoomLevel + 0.1);
        }
        break;
    }
    this.applyZoom();
  }

  applyZoom() {
    const content = document.querySelector('body') as any;
    if (content) {
      content.style.zoom = this.zoomLevel;
    }
  }



  prepopulationOfAddmission(StuId) {
    // this.spinner.show();
    let payload = {};
    payload['StuId'] = StuId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.addmissionData = res.data[0];
        this.CoCode = res.data[0].StuCoId
        sessionStorage.setItem("StuEmId", res.data[0].StuEmId);
        sessionStorage.setItem("StuCoId", res.data[0].StuCoId);
        sessionStorage.setItem("StuCgId", res.data[0].StuCgId);
        this.courseShId();
        this.getRgId(StuId)
      }
    })
  }

  openExamEligibility(e) {
    console.log('open eligibility is called');

    this.spinner.hide();
    const setActiveClass = (elementId) => {
      document.getElementById(elementId).setAttribute('class', 'nav-item active show');
    };

    if (e == 'Subject-Selection') {
      this.FormParamete = 'Admission'
    }
    else if (e == 'Exam-Form') {
      this.FormParamete = 'Examination'
    }
    else if (e == 'Admit-Card') {
      this.FormParamete = 'IaAdmitCard'
    }
    this.dialogRef = this.dialog.open(ExamEligibilityComponent, {
      width: '170vh',
      height: '85vh',
      disableClose: true,
      data: this.FormParamete,
    });
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'Continue') {
        if (e == 'Subject-Selection') {
          this.redirect('Subject-Selection');
        }
        else if (e == 'Exam-Form') {
          this.getSubjectSelectionData()
        }
        else if (e == 'Admit-Card') {
          this.redirect(e);
          setActiveClass(e);
        }



      } else {
        // this.ngOnInit();
      }
    });
  }

  checkSession() {
    const payload = {};
    payload['SnNo'] = sessionStorage.getItem('session');;
    this.umsService.getSession(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0]['SnName'].includes('Re')) {
          this.ReExam = true;
        }
        else {
          this.ReExam = false;
        }
      }
    })
  }

  getSubjectSelectionData() {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId")
    payload['SubSession'] = parseInt(sessionStorage.getItem('session'));
    this.umsService.getSubSelectionDetails(payload).subscribe(res => {
      if (res.data == '') {
        let data = {}
        this.spinner.hide();
        if (this.ReExam == false) {
          data['message'] = "First Select Subject in Subject Selection"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-box-open'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        }
        else {
          this.redirect('Exam-Form');
        }


      } else {
        this.redirect('Exam-Form');
        // setActiveClass('Exam-Form');
      }
    });
  }

  // prepopulationPersonal() {
  //   // this.spinner.show();
  //   let payload = {};
  //   payload['StuRgNo'] = this.studentId;
  //   this.umsService.fetchPersonalDetails(payload).subscribe((res) => {

  //     if (res.status) {
  //       if (res.data.length > 0) {
  //         sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
  //         this.StuFullName = res.data[0].StuFirstNameEng + ' ' + res.data[0].StuMidNameEng + ' ' + res.data[0].StuLastNameEng;
  //         this.spinner.hide();
  //       } else {
  //       }
  //     } else {
  //     }
  //   })
  // }

  getSubselectEditControl(Shid) {
    let payload = {};
    payload['EcShId'] = Shid;
    payload['EcInCode'] = 64;
    payload['EcOpId'] = 0;
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        if (res.status) {
          this.subjectSelectioMenu = true;
        } else {
          this.subjectSelectioMenu = false;
        }
      });
  }

  getUserData(id) {
    // this.FirstName = ''
    // this.MiddleName = ''
    // this.LastName = ''
    // this.Number = 0
    // this.Email = ''
    this.umsService.getUserData(id).subscribe((res) => {
      console.log('res of user data', res.data);
      console.log('res of deb stud', res.data[0][0]['StudebID']);
      // for now there is no StudebID field in userdata for muhs
      // if(res.data[0][0]['StudebID'] != '' || res.data[0][0]['StudebID'] != undefined){
      //   this.StuFullName =  res.data[0][0]['StuFullName'];
      // }
      // else{
      //   console.log('im in else condition');

      //   this.StuFullName =  res.data[0][0]['StuFirstName'] + ' ' + res.data[0][0]['StuMidName'] + ' ' + res.data[0][0]['StuLastName'];
      //   sessionStorage.setItem('StuFirstName',res.data[0][0]['StuFirstName']);
      //   sessionStorage.setItem('StuMidName',res.data[0][0]['StuMidName']);
      //   sessionStorage.setItem('StuLastName',res.data[0][0]['StuLastName']);
      //   sessionStorage.setItem('StuMobNumber',res.data[0][0]['StuMobNumber']);
      //   sessionStorage.setItem('StuEmailId',res.data[0][0]['StuEmailId']);
      // }   
      sessionStorage.setItem('StuFirstName', res.data[0][0]['StuFirstName']);
      sessionStorage.setItem('StuMidName', res.data[0][0]['StuMidName']);
      sessionStorage.setItem('StuLastName', res.data[0][0]['StuLastName']);
      sessionStorage.setItem('StuMobNumber', res.data[0][0]['StuMobNumber']);
      sessionStorage.setItem('StuEmailId', res.data[0][0]['StuEmailId']);
      console.log('this.StuFullName', this.StuFullName);
      if ((res.data[0][0]['StuFirstName'] == undefined || res.data[0][0]['StuFirstName'] == null)
        || (res.data[0][0]['StuMidName'] == undefined || res.data[0][0]['StuMidName'] == null)
        || (res.data[0][0]['StuLastName'] == undefined || res.data[0][0]['StuLastName'] == null)) {
        this.StuFullName = this.OldStudentName;
      } else {
        this.StuFullName = res.data[0][0]['StuFirstName'] + ' ' + res.data[0][0]['StuMidName'] + ' ' + res.data[0][0]['StuLastName'];

      }
      if (this.userType == 'new' || this.userType === 'new') {
        this.ShowMenu = true;
      } else {
        this.ShowMenu = false;
      }


    });


  }

  SubjectSelectionData(StuId) {
    const payload = {};
    payload['StuId'] = StuId,
      this.umsService.StudentSubjectSelectionById(payload).subscribe(res => {
        if (res.status) {
          const latestObject = res.data[res.data.length - 1];
          if (parseInt(latestObject['SubSession']) == parseInt(sessionStorage.getItem('session'))) {
            this.SessionStatus = "Current Session"
            this.getSessionData(parseInt(sessionStorage.getItem('session')))
          }
          else if (parseInt(latestObject['SubSession']) < parseInt(sessionStorage.getItem('session'))) {
            this.SessionStatus = "Previous Session"
            this.getSessionData(parseInt(latestObject['SubSession']))
          }
        }
        else {

        }
      })
  }

  getSessionData(SnNo) {
    this.SessionNo = SnNo
    this.spinner.show();
    const payload = {};
    payload['SnNo'] = SnNo;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionName = res.data[0]['SnName'];
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
    this.getApplyData(SnNo);
  }



  changePassword() {
    // this.redirect('change-password')
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '37%',
      data: { key: "New" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      // this.getUserData();
      // this.UserSearch.controls['SearchString'].setValue('');
    });
  }

  courseShId() {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CShStatus'] = '';
    payload['LoginId'] = sessionStorage.getItem("loginId");
    payload['CShSnNo'] = sessionStorage.getItem("session");
    this.umsService.NewCoSch(payload).subscribe(res => {
      //Step 2)if course is scheduled then check registration list open or not else show error message.
      if (res.status) {
        this.spinner.hide()
        this.checkRegister(res.data[0]['CShId'])
      }
      else {
        this.grievanceUpdate = false
        this.spinner.hide()
        // let data = {}
        // data['message'] = "Course Not Scheduled"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.grievanceUpdate = false
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  checkRegister(ShId) {
    this.spinner.show()
    const payload = {};
    payload['CEcInCode'] = 51;
    payload['CEcShId'] = ShId;
    payload['CEcOpId'] = 1;
    this.umsService.getSupCourseEditRecord(payload).subscribe(res => {
      //Step 3)check whether regitration list open or updated to show validation message. if open then hit scrutiny api
      if (res.status) {
        this.spinner.hide()
        if (res.data[0].CEcStatus == "U") {
          this.grievanceUpdate = true
          // let data = {}
          // data['message'] = "Registration closed"
          // data['title'] = 'Information'
          // data['icon'] = 'fas fa-check'
          // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

        } else {  //this condition defines that registration list is open
          // this.submitScrutiny();
        }
      }
      // else {
      //   this.spinner.hide()
      //   let data = {}
      //   data['message'] = "Registration List Not Open"
      //   data['title'] = 'Information'
      //   data['icon'] = 'fas fa-check'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      // }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  GetFailStudStatus(RgId) {
    const payload = {};
    payload['RgId'] = RgId;
    this.umsService.GetFailStudStatus(payload).subscribe(res => {
      if (res.status) {
        this.Failed = true;
      }
      else {
        this.Failed = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Failed = true;
      this.spinner.hide();
    })
  }

  getApplyData(SnNo) {
    // this.getList(SnNo)
    this.spinner.show();
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        console.log("im in get apply data");
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getList() {
    console.log("iiiiiiiiiii in list");

    this.spinner.show();
    const payload = {
      CoCode: '',
      SnNo: sessionStorage.getItem('session'),
      CgCode: '',
      ApplicationType: 'Student',
    };

    this.umsService.getStuNotify(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          console.log('Received notifications:', res.data);
          const distinctNotifications = res.data.filter((item, index, self) =>
            index === self.findIndex((t) => t.NotTitle === item.NotTitle && t.NotDesc === item.NotDesc)
          );
          this.NotificationCount = distinctNotifications.filter(item => item.ReadStatus == 'N').length;
          this.NotificationAllData = res.data;
          this.NotificationsData = distinctNotifications.map((item: any) => ({
            title: item.NotTitle,
            description: item.NotDesc,
            date: item.CreatedAt ? new Date(item.CreatedAt) : new Date('2000-01-01T00:00:00') // Default date
          }));
        } else {
          this.NotificationCount = 0;
          this.NotificationsData = [];
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        console.error('Error fetching notifications:', error);
        this.NotificationsData = [];
        this.NotificationCount = 0;
      }
    );
  }

  ShowNotification(dropdown: HTMLElement) {
    console.log('im clicked');
    this.spinner.show();
    this.renderer.removeClass(dropdown, 'show');
    const distinctNotifications = this.NotificationAllData.filter((item, index, self) =>
      index === self.findIndex((t) => t.NotTitle === item.NotTitle && t.NotDesc === item.NotDesc)
    );
    const unreadNotificationIds = distinctNotifications
      .filter(notification => notification.ReadStatus === 'N')
    let iserror = false;
    console.log('unreadNotificationIds', unreadNotificationIds);
    const payload = unreadNotificationIds.map(notification => ({
      ...notification,
      ReadStatus: 'Y' // Update ReadStatus to 'Y'
    }));

    if (unreadNotificationIds.length > 0) {
      var bar = new Promise<void>((resolve, reject) => {
        payload.forEach((element, index, array) => {
          console.log('payload', element);
          setTimeout(() => {
            this.umsService.UpdtStuNotify(element).subscribe(res => {
              // this.spinner.hide();
              if (res.status == false) {
                // this.spinner.hide()
                iserror = true;
                this.errMsg = res.message;
              } else {
                // this.spinner.hide()
                iserror = false;
                this.errMsg = res.message;
              }
              if (index === array.length - 1) resolve();
              // this.fetchDocument();

            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              iserror = true;
              this.errMsg = ERROR.error.message;
              if (index === array.length - 1) resolve();
            });
          }, index * 2000);
        });

      })
      bar.then(() => {
        // this.spinner.hide();
        if (iserror == false) {
          this.spinner.hide();
          this.redirect('notifications');
          this.NotificationCount = 0;
        } else {
          this.spinner.hide();

        }
      });
    }
    else {
      this.redirect('notifications');
    }

  }

}